import { useI18n } from "@baton/i18n";
import { useRef, type ReactNode } from "react";
import { useRouteMeta } from "../routes/meta.ts";

/**
 * 001 FR-159, `contracts/screens.md` § Error and utility screens (2026-09-29): the page a member
 * sees at a Team an instance admin suspended. Every route of the Team answers 403
 * `workspace_suspended` until the suspension is lifted, so the page says so plainly, names the Team
 * from the person's own memberships, and offers the switcher to their other Teams. It offers no
 * request for access, since the Team's owner cannot lift a suspension; an instance admin does.
 */
export function TeamSuspended({ name, switcher }: { readonly name: string; readonly switcher: ReactNode }) {
  const { t } = useI18n();
  const heading = useRef<HTMLHeadingElement>(null);
  useRouteMeta({ screen: "noAccess.suspendedTitle", focus: heading });
  return (
    <div className="b-no-access" role="alert">
      <h1 ref={heading} tabIndex={-1} className="b-no-access__title">
        {t("noAccess.suspendedTitle")}
      </h1>
      <p className="b-no-access__body">{t("noAccess.suspendedBody", { name })}</p>
      <div className="b-no-access__switcher" data-chrome>
        {switcher}
      </div>
    </div>
  );
}
